import { ReportingItem } from '@customer/hooks/assets/useAssetReportingTableData';
import { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type Model = ReportingItem;

export const useReportingColDefs = (): ColDef<Model>[] => {
  const { t } = useTranslation();

  const colDefs = useMemo<ColDef<Model>[]>(
    () => [
      { field: 'evt', headerName: t('Event') },
      { field: 'date', headerName: t('Date') },
      { field: 'time', headerName: t('Time') },
      { field: 'when', headerName: t('When') },
    ],
    [t],
  );

  return colDefs;
};
